import {translate} from "@prosay/i18n"
import React, {useCallback, useMemo} from "react"
import {FlatList} from "react-native"
import {
    Button,
    Caption,
    Dialog,
    Portal,
    Surface,
    Text,
    TouchableRipple,
} from "react-native-paper"
import {Actions} from "react-native-router-flux"
import {
    GettingStartedExampleInfoFragment,
    useGetTopicCategoriesQuery,
} from "../../graphql"

const onExamplePressed = ({
    question,
    topic,
}: GettingStartedExampleInfoFragment) => {
    Actions.createConversation()
    setImmediate(() => Actions.writeDescription({question, topic}))
}

export interface GettingStartedProps {}
export const GettingStarted: React.FC<GettingStartedProps> = ({}) => {
    const onDismiss = useCallback(() => Actions.pop(), [])
    const {data, loading, refetch} = useGetTopicCategoriesQuery()
    const examples = useMemo(
        () =>
            (data?.getTopicCategories ?? [])
                .flatMap(({topics}) => topics)
                .flatMap(({examples, ...topic}) =>
                    examples.map(example => ({...example, topic})),
                ),
        [data],
    )

    return (
        <Portal>
            <Dialog visible dismissable onDismiss={onDismiss}>
                <Dialog.Title>
                    {translate("ui.screen.gettingStarted.title")}
                </Dialog.Title>

                <Dialog.Content style={{maxHeight: "70vh"}}>
                    <FlatList
                        data={examples}
                        refreshing={loading}
                        onRefresh={refetch}
                        keyExtractor={({id}) => id}
                        renderItem={({item}) => (
                            <TouchableRipple
                                onPress={() => onExamplePressed(item)}>
                                <Surface
                                    style={{elevation: 2, marginVertical: 10}}>
                                    <Text>{item.question}</Text>
                                    <Caption>{`${item.topic.name} - ${item.topic.category.name}`}</Caption>
                                </Surface>
                            </TouchableRipple>
                        )}
                    />
                </Dialog.Content>
                <Dialog.Actions>
                    <Button onPress={onDismiss}>Done</Button>
                </Dialog.Actions>
            </Dialog>
        </Portal>
    )
}
